import React, { Component } from 'react'

import style from './style.module.css'

class Modal extends Component {

    state = {
        type: null,
        active: false,
    }

    constructor(props) {
        super(props)
        this.hide = this.hide.bind(this)
        this.body = document.body || document.documentElement
    }

    ignoreClose(e) {
        e.stopPropagation()
    }

    fixBody() {
        this.fixed = true
        
        this.body.style.position = 'fixed'
        this.body.style.height = '100%'
        this.body.style.overflowY = 'hidden'
    }

    unFixBody() {
        if(this.fixed) {
            this.body.style.position = 'relative'
            this.body.style.height = 'auto'
            this.body.style.overflowY = 'auto'
        }
    }

    componentDidMount() {
        this.eventListener = function(evt) {
            var keyCode = evt.keyCode ? evt.keyCode :
                evt.charCode ? evt.charCode :
                evt.which ? evt.which : void 0
            if (keyCode === 27) {
                this.hide()
                evt.stopPropagation()
                evt.preventDefault()
            }
        }.bind(this)

        this.hashListener = function(evt) {
            if(window.location.hash === this.props.hash) {
                this.fixBody()
                this.setState({
                    active: true
                })
            } else {
                this.unFixBody()

                this.setState({
                    active: false
                })
            }
        }.bind(this)

        this.hashListener()

        window.addEventListener('keydown', this.eventListener)
        window.addEventListener('hashchange', this.hashListener)
    }

    componentWillUnmount(){
        this.unFixBody()
        window.removeEventListener('keydown', this.eventListener)
    }

    hide(e) {
        window.history.pushState("", document.title, window.location.pathname + window.location.search)
        this.unFixBody()
        this.setState({
            active: false
        })

        if(e)
        e.stopPropagation()
    }

    render() {
        if(!this.state.active) return null

        return (
            <div ref='scrollable'
                onScroll={(event) => {
                    this.props.handleScroll && this.props.handleScroll(event)
                }}
                className={`${style.background}
                ${this.state.active ? style.active : ''}`}
                onClick={this.hide}>

                <div className={`${style.modalContainer} ${this.props.full ? style.full : ''}`} onClick={this.hide}>

                    <div className={style.modalTable}>
                        <div className={style.modalCell}>

                            <div
                                className={style.modalContent}
                                style={this.props.style}
                                onClick={this.ignoreClose}
                                ref='content'
                            >
                                {!this.props.hideClose && (
                                    <div className={style.modalClose} onClick={this.hide}>&#215;</div>
                                )}
                                {(this.props.loadContent === undefined || this.props.loadContent) && (
                                    <div>
                                        {this.props.content()}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Modal



// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/ModalHash/index.js